import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

export default function Scroll() {

    const [showClass, setshowClass] = useState(false);
  
    React.useEffect(() => {
        window.addEventListener('scroll', () => {
            let scoll = null;
            if(window.scrollY < 100){
                scoll = false;
            }else{
                scoll = true; 
            }
            setshowClass(scoll);
        });
    }, [])

    const scrollTop = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
    return (
        <div className="scroll-to-top">
            <div id="bottom-to-top" onClick={() => scrollTop()} title="Back to top" className={showClass ? 'show' : ''}>
                <div className="scroll-icon">
                    <FontAwesomeIcon icon={faArrowUp} />
                </div>
            </div>
         </div>
    )
}

